<template>
<transition name="modal-fade">
    <div>
        <div class="modal-mask" @click="$emit('close')"></div>
        <div class="modal-content">
            <div class="modal-wrapper">
                <div v-bind:class="container">
                    <div class="modal-header">
                        <slot name="header">
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body">
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    name: 'modal',
    props: {
        container: String,
    },
};
</script>
